import Image from 'next/image'

const logosInner = ['logo-1-1', 'logo-1-2', 'logo-1-3', 'logo-1-4', 'logo-1-5']
const logosOuter = ['logo-2-1', 'logo-2-2', 'logo-2-3', 'logo-2-4', 'logo-2-5']

export default function Orbit() {
  return (
    <div
      className='relative m-auto flex w-full items-center justify-center'
      style={{
        height: 480
      }}
    >
      <span className='orbit-lines orbit-lines-0 absolute'>
        <Image
          alt='Orbit Lines'
          height={600}
          src={`/images/animations/orbit/orbit-lines.png`}
          style={{
            opacity: 0.3
          }}
          width={600}
        />
      </span>
      <span className='orbit-lines orbit-lines-1 absolute'>
        <Image alt='Orbit Lines' height={400} src={`/images/animations/orbit/orbit-lines.png`} width={400} />
      </span>
      <span className='orbit-lines orbit-lines-2 absolute'>
        <Image alt='Orbit Lines' height={400} src={`/images/animations/orbit/orbit-lines.png`} width={400} />
      </span>
      <div className='orbit-logos orbit-logos-1 absolute'>
        {logosInner.map((logo, logoIndex) => {
          return <OrbitLogo key={logoIndex} layer={1} logo={logo} logoIndex={logoIndex} logos={logosInner} />
        })}
      </div>
      <div className='orbit-logos orbit-logos-2 absolute'>
        {logosOuter.map((logo, logoIndex) => {
          return <OrbitLogo key={logoIndex} layer={2} logo={logo} logoIndex={logoIndex} logos={logosOuter} />
        })}
      </div>
      <span className='absolute h-28 w-28 rounded-full bg-gray-900'></span>
    </div>
  )
}

type OrbitLogoProps = {
  logo: string
  logoIndex: number
  layer: number
  logos: Array<string>
}

function OrbitLogo({ layer, logo, logoIndex, logos }: Readonly<OrbitLogoProps>) {
  const rotationDeg = 360 / logos.length

  return (
    <span
      className={`expand-orbit-${layer}`}
      style={{
        transform: `rotate(${rotationDeg * logoIndex}deg)`
      }}
    >
      <span className={layer === 1 ? 'rotate-counter' : 'rotate'}>
        <Image
          alt='Orbit Logo'
          height={50}
          src={`/images/animations/orbit/${logo}.png`}
          style={{
            transform: `rotate(-${rotationDeg * logoIndex}deg)`
          }}
          width={50}
        />
      </span>
    </span>
  )
}
